export enum REFERRAL_STATUS {
  OPENED_IN_SYSTEM = 1,
  UNDER_REVIEW = 4,
  APPROVED = 5,
  ON_HOLD = 7,
  REJECTED = 8,
}
